import { constants, typographyStyles } from "@newsela/angelou";

const { ui } = constants.colors;

const { textS } = typographyStyles;
export const contentSettingsCheckboxCss = {
  display: "flex",
  "& > label": {
    padding: "4px",
    outlineOffset: "-2px",
    "& > input": {
      position: "absolute !important",
    },
  },
};

export const contentSettingsContainerCss = {
  position: "relative",
  zIndex: 100,
  paddingTop: 16,
  marginLeft: -24,
  marginRight: -24,
  paddingLeft: 24,
  paddingRight: 24,
  borderTop: `1px solid ${ui.neutral[100]}`,
};

export const contentSettingsTextCss = [...textS, { fontWeight: "bold" }];
